export default [
  {
    title: "선박 블록(Block)",
    list: [
      {
        content: "전도방지 지그 상태 확인",
        isChecked: "",
      },
      {
        content: "레버플러 후크 상태 확인",
        isChecked: "",
      },
      {
        content: "피스는 양면 용접",
        isChecked: "",
      },
      {
        content: "피벗 클램프 사용",
        isChecked: "",
      },
      {
        content: "덮개판은 규격품 사용",
        isChecked: "",
      },
      {
        content: "해머 고정상태 확인",
        isChecked: "",
      },
      {
        content: "크레인으로 부재 운반 시 정격하중 확인 철저",
        isChecked: "",
      },
      {
        content: "작업 전후 청소 및 정리정돈",
        isChecked: "",
      },
    ],
  },
  {
    title: "탱크(Tank) 내",
    list: [
      {
        content: "조명상태 확인",
        isChecked: "",
      },
      {
        content: "환기 팬(Fan) 가동 후 작업",
        isChecked: "",
      },
      {
        content: "물건을 든 상태로 수직 사다리 이동 금지",
        isChecked: "",
      },
      {
        content: "이면(하부) 확인 후 안전조치 사전 실시",
        isChecked: "",
      },
      {
        content: "작업 전 절단토치 연결상태 확인",
        isChecked: "",
      },
      {
        content: "휴식시간에는 토치를 분리",
        isChecked: "",
      },
      {
        content: "공구 등은 반드시 보관함에 보관",
        isChecked: "",
      },
      {
        content: "레버플러 후크 상태 확인",
        isChecked: "",
      },
      {
        content: "피벗 클램프 사용",
        isChecked: "",
      },
      {
        content: "헤머 고박상태 확인",
        isChecked: "",
      },
      {
        content: "피스는 반드시 양면 용접",
        isChecked: "",
      },
      {
        content: "덮개판은 규격품 사용",
        isChecked: "",
      },
      {
        content: "작업 전후 청소 및 정리정돈",
        isChecked: "",
      },
    ],
  },
];
